<template>
    <div id="forecast-setup-date">
        <section class="step forecast">
            <div class="step-title"><span class="number">1</span>{{ $t('production.select.step_confirm_forecast') }}</div>
            <div class="content">                                   
                    <div class="channel chart-container">
                        <div class="name">{{ $t('production.select.restaurant') }}</div>
                        <div v-if="isAdjustable" class="selector sales-ref">
                            <select v-model="salesChannels.general.type" class="input" @change="changeType($event, 'general', 'sales')">
                                <option value="weekday">{{ $t('production.init.projection_calculated') }}</option>
                                <option value="custom">{{ $t('production.select.select-date') }}</option>
                            </select>
                            <localized-date-picker v-if="salesChannels.general.type == 'custom'" v-model="salesChannels.general.value" class="input date" :max="maxDate" :min="minDate" @change="changeDate($event, 'general', 'sales')" />
                        </div>
                        <div v-if="isLoading" class="loading"></div>
                        <template v-else-if="forecast">
                            <div v-if="isAdjustable" class="modifier">
                                <div class="modifier-container">
                                    <span class="title">{{ $t('production.init.modifier_title') }}</span>
                                    <span class="description">{{ $t('production.init.modifier_description') }}</span>
                                </div>
                                <div class="input" @click="setModifier('general')">{{ modifier.general }}%</div>
                            </div>
                            <div class="chart">
                                <ChartSales :series1="forecast.general.sales_forecast.sales_forecast"></ChartSales>
                            </div>
                            <div class="summary">
                                <div class="sales">
                                    {{ $t('production.select.sale') }} <span>{{ formatCurrency(forecast.general.sales_forecast.total) }}</span>
                                </div>
                            </div>
                        </template>
                        
                    </div>
                    <div class="channel chart-container">
                        <div class="name">{{ $t('production.select.delivery') }}</div>
                        <div v-if="isAdjustable" class="selector sales-ref">
                            <select v-model="salesChannels.delivery.type" class="input" @change="changeType($event, 'delivery', 'sales')">
                                <option value="weekday">{{ $t('production.init.projection_calculated') }}</option>
                                <option value="custom">{{ $t('production.select.select-date') }}</option>
                            </select>
                            <localized-date-picker v-if="salesChannels.delivery.type == 'custom'" v-model="salesChannels.delivery.value" class="input date" :max="maxDate" :min="minDate" @change="changeDate($event, 'delivery', 'sales')" />
                        </div>
                        <div v-if="isLoading" class="loading"></div>
                        <template v-else-if="forecast">
                            <div v-if="isAdjustable" class="modifier">
                                <div class="modifier-container">
                                    <span class="title">{{ $t('production.init.modifier_title') }}</span>
                                    <span class="description">{{ $t('production.init.modifier_description') }}</span>
                                </div>
                                <div class="input" @click="setModifier('delivery')">{{ modifier.delivery }}%</div>
                            </div>
                            <div class="chart">
                                <ChartSales :series1="forecast.delivery.sales_forecast.sales_forecast"></ChartSales>
                            </div>
                            <div class="summary">
                                <div class="sales">
                                    {{ $t('production.select.sale') }} <span>{{ formatCurrency(forecast.delivery.sales_forecast.total) }}</span>
                                </div>
                            </div>
                        </template>
                    </div>
            </div>
        </section>
        <section class="step pmix">
            <div class="step-title"><span class="number">2</span>{{ $t('production.select.step_confirm_pmix') }}</div>
            <div class="content">                                   
                <div class="channel">
                    <div class="name">{{ $t('production.select.restaurant') }}</div>
                    <div class="selector">
                        <select v-model="pmixChannels.general.type" class="input" @change="changeType($event, 'general', 'pmix')">
                            <option value="weekday">{{ $t('production.select.last') }} {{ formatDate(weekdayDate) }}</option>
                            <option value="custom">{{ $t('production.select.select-date') }}</option>
                        </select>
                        <localized-date-picker v-if="pmixChannels.general.type == 'custom'" v-model="pmixChannels.general.value" class="input date" :max="maxDate" :min="minDate" @change="changeDate($event, 'general', 'pmix')" />
                    </div>
                </div>
                <div class="channel">
                    <div class="name">{{ $t('production.select.delivery') }}</div>
                    <div class="selector">
                        <select v-model="pmixChannels.delivery.type" class="input" @change="changeType($event, 'delivery', 'pmix')">
                            <option value="weekday">{{ $t('production.select.last') }} {{ formatDate(weekdayDate) }}</option>
                            <option value="custom">{{ $t('production.select.select-date') }}</option>
                        </select>
                        <localized-date-picker v-if="pmixChannels.delivery.type == 'custom'" v-model="pmixChannels.delivery.value" class="input date" :max="maxDate" :min="minDate" @change="changeDate($event, 'delivery', 'pmix')" />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ChartSales from './chartSales.vue'
import { formatDate, isValidDate } from '@/utils/dateUtils'
import { formatCurrency } from "@/utils/formatters";

export default {
    components: {
        ChartSales,
    },
    name: 'ForecastSetupDate',
    props: {
        date: { type: String },
        forecast: { type: Object },
        isLoading: { type: Boolean },
        isAdjustable: { type: Boolean },
        oModifier: { type: Object },
        salesChannelConfig: { type: Object, default: null },
        pmixChannelConfig: { type: Object, default: null }
    },
    data() {
        return {
            salesChannels: {'general': {'type': 'weekday', 'value': ''}, 'delivery': {'type': 'weekday', 'value': ''}},
            pmixChannels: {'general': {'type': 'weekday', 'value': ''}, 'delivery': {'type': 'weekday', 'value': ''}},
            maxDate: '',
            minDate: '',
            weekdayDate: '',
            modifier: {'general': 0, 'delivery': 0},
        }
    },
    computed: {
    },
    methods: {
        formatDate,
        changeType(e, channel, section) {
            const channels = section === 'sales' ? this.salesChannels : this.pmixChannels
            if (e.target.value == 'weekday') {
                if (channel == 'general') {
                    channels.general.type = 'weekday'
                    channels.general.value = this.weekdayDate
                } else if (channel == 'delivery') {
                    channels.delivery.type = 'weekday'
                    channels.delivery.value = this.weekdayDate
                }
            }
            this.emitSectionUpdate(section, channels)
        },
        changeDate(e, channel, section) {
            const channels = section === 'sales' ? this.salesChannels : this.pmixChannels
            if (channel == 'general') {
                channels.general.value = e.target.value
                channels.general.type = 'custom'

                if (channels.delivery.type == 'weekday') {
                    channels.delivery.type = 'custom'
                    channels.delivery.value = channels.general.value
                }

            } else if (channel == 'delivery') {
                channels.delivery.value = e.target.value
                channels.delivery.type = 'custom'
            }
            this.emitSectionUpdate(section, channels)
        },
        emitSectionUpdate(section, channels) {
            if (section === 'sales') {
                this.$emit('updateSalesConfig', channels)
            } else {
                this.$emit('updatePmixConfig', channels)
            }
        },
        resetBlockFromConfig(channels, config) {
            const weekdayVal = moment(this.date).locale('en').format('dddd').toLowerCase()
            if (config && config.general !== undefined && config.delivery !== undefined) {
                const generalVal = config.general
                const deliveryVal = config.delivery
                channels.general = {
                    type: isValidDate(generalVal) ? 'custom' : 'weekday',
                    value: generalVal
                }
                channels.delivery = {
                    type: isValidDate(deliveryVal) ? 'custom' : 'weekday',
                    value: deliveryVal
                }
            } else {
                channels.general = { type: 'weekday', value: weekdayVal }
                channels.delivery = { type: 'weekday', value: weekdayVal }
            }
        },
        reset() {
            this.resetBlockFromConfig(this.salesChannels, this.salesChannelConfig)
            this.resetBlockFromConfig(this.pmixChannels, this.pmixChannelConfig)
            this.maxDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
            this.minDate = moment().subtract(3, 'months').format('YYYY-MM-DD')
            this.weekdayDate = moment(this.date).locale('en').format('dddd').toLowerCase()
        },
        setModifier(channel) {
            let self = this
            this.$popup.numeric({
                title: self.$t('production.init.modifier_title'),
                message: self.$t('production.init.modifier_description'),
                inputVal: String(self.modifier[channel]),
                hasNegative: true,
                decimal: false,
                callSave: async function (context, store) {
                    self.modifier[channel] = parseInt(context.inputVal)
                    self.$emit('updateModifier', {date: self.date, modifier: self.modifier})
                }
            })
        },
        formatCurrency(amount) {
            return formatCurrency(amount)
        }
    },
    created() {
        this.reset()
        if (this.oModifier && typeof this.oModifier === 'object') {
            this.modifier = {
                general: this.oModifier.general != null ? this.oModifier.general : 0,
                delivery: this.oModifier.delivery != null ? this.oModifier.delivery : 0
            }
        }
    },
    watch: {
        date(newVal, oldVal) {
            if (newVal != oldVal) {
                this.reset()
                if (this.oModifier && typeof this.oModifier === 'object') {
                    this.modifier = {
                        general: this.oModifier.general != null ? this.oModifier.general : 0,
                        delivery: this.oModifier.delivery != null ? this.oModifier.delivery : 0
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    #forecast-setup-date {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;

        .step {
                display: flex;
                flex-direction: column;
                width: 100%;
                background-color: $color-white;
                border-radius: 4px;
                padding: 8px;
                

                .step-title {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    justify-content: left;
                    font-family: $text-bold;
                    @include font-size(m);
                    background-color: $color-neutral-50;
                    padding: 8px;

                    .number {
                        font-family: $text-bold;
                        @include font-size(m);
                        margin-right: 10px;
                        background-color: $color-white;
                        width: 20px;
                        height: 20px;
                        text-align: center;
                        line-height: 20px;
                        border-radius: 4px;
                    }
                }

        .content {
            width: 100%;
            display: flex;
            flex-direction: row;
            padding-bottom: 0;
            padding-top: 8px;
            gap: 8px;

                .channel {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    padding: 8px 4px;
                    padding-bottom: 0;
                    padding-top: 4px;
                    border: 1px solid $color-neutral-300;
                    border-radius: 4px;
                    padding: 8px;
                    position: relative;

                    &.chart-container {
                        min-height: 250px;
                    }

                    .name {
                        font-family: $text-bold;
                        @include font-size(sm);
                        margin-bottom: 8px;
                        text-align: left;
                        text-transform: uppercase;
                        &.forecastDefrost {
                            margin-bottom: 8px;
                        }
                    }
                    .selector {
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        gap: 10px;
                        &.weekday {
                            justify-content: center;
                        }

                        .input {
                            /* display: flex;
                            flex-direction: column;  */
                            width: 100%;
                            height: 45px;
                            padding: 4px;
                            padding-left: 12px;
                            border: 1px solid #ccc;
                            border-radius: 3px;
                            color: $color-black;
                            justify-content: center;
                            line-height: 20px;
                        }
                    }
                    .summary {
                        margin-top: 8px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        align-content: stretch;
                        justify-content: space-around;
                        align-items: center;
                        width: 100%;
                        text-transform: uppercase;
                        @include font-size(s);

                        .sales,
                        .reference-date {
                            font-family: $text;
                            text-align: center;
                            span {
                                font-family: $text-bold;
                                @include font-size(s);
                            }
                        }
                    }
                    .chart {
                        width: 100%;
                        height: 225px;
                        background-color: #fff;
                        border-radius: 3px;
                        float: none;
                        overflow: hidden;
                        margin-top: 8px;

                    }
                    .modifier {
                        padding: 8px;
                        background-color: $color-neutral-50;
                        border-radius: 4px;
                        display: flex;
                        flex-direction: row;
                        gap: 8px;

                        .modifier-container {
                            display: flex;
                            flex-direction: column;
                            align-items: left;
                            justify-content: left;
                            width: calc(100% - 100px);
                            .title {
                                font-family: $text-bold;
                                @include font-size(s);
                            }
                            .description {
                                font-family: $text;
                                @include font-size(xs);
                                line-height: 12px;
                            }
                        }
                        .input {
                            width: 100px;
                            height: 40px;
                            line-height: 40px;
                            padding-left: 12px;
                            border: 1px solid #ccc;
                            border-radius: 3px;
                            @include background($image: img('edit_neutro.svg'), $size: 15px, $position: right 8px center);
                            background-color: $color-white;
                            cursor: pointer;
        
                        }
                    }
                }
            }
            
        }
        .loading {
            @include background($image: img('loader_dark.svg'), $size: 60px, $position: center center);
            width: 100%;
            height: 100%;
            position: absolute;
        }
    }

</style>
